class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    this.searchIcon = this.querySelector('.search-icon-h');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
      this.input.addEventListener('blur', this.onInputBlur.bind(this));
      this.input.addEventListener('click', this.onInputClick.bind(this));
    }

    window.addEventListener('resize', this.handleWindowResize.bind(this));
    this.handleWindowResize();
  }

  toggleResetButton(visible) {
    if (visible) {
      this.resetButton.classList.remove('hidden');
    } else {
      this.resetButton.classList.add('hidden');
    }
  }
  

  toggleSearchIconVisibility(visible) {
    if (this.searchIcon) {
      this.searchIcon.style.display = visible ? 'flex' : 'none';
    }
  }

  onChange() {
    this.toggleResetButton(this.input.value.length > 0);
    this.toggleSearchIconVisibility(this.input.value.length === 0);
  }

  onFormReset(event) {
    event.preventDefault();
    this.input.value = '';
    this.input.focus();
    this.toggleResetButton(false);
  }

  onInputFocus() {
    this.toggleResetButton(true);
    this.toggleSearchIconVisibility(false);
  }

  onInputBlur() {
    if (this.input.value === '') {
      this.toggleResetButton(false);
      this.toggleSearchIconVisibility(true);
    }
  }

  onInputClick() {
    this.toggleResetButton(true);
    this.toggleSearchIconVisibility(false);
  }

  handleWindowResize() {
    const isMobile = window.innerWidth <= 999;
    this.isMobile = isMobile;

    if (this.isMobile) {
      this.input.addEventListener('focus', this.onInputFocus.bind(this));
      this.input.addEventListener('blur', this.onInputBlur.bind(this));
      this.input.addEventListener('click', this.onInputClick.bind(this));
    } else {
      this.input.removeEventListener('focus', this.onInputFocus.bind(this));
      this.input.removeEventListener('blur', this.onInputBlur.bind(this));
      this.input.removeEventListener('click', this.onInputClick.bind(this));
    }
  }
}

customElements.define('search-form', SearchForm);

// document.addEventListener('DOMContentLoaded', function () {
//   const clearButton = document.querySelector('.reset__button');
//   if (clearButton) {
//     clearButton.classList.add('hidden');
//   }
// });


